export const normalizeAddressingLine = (addressingLine: string): string => addressingLine.replace(/\s/g, '')
